import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/support/contact", payload);
  return data;
}

export async function joinWaitlist(payload) {
  const { data } = await api.post("/waitlist", payload);
  return data;
}

export async function logInstallEvent(kind, path) {
  try {
    await api.post("/analytics/install-event", {
      kind,
      path: path || window.location.pathname,
      ua: navigator.userAgent,
    });
  } catch {
    /* non-blocking */
  }
}
